import VueApexCharts from 'vue-apexcharts'
import _ from 'lodash'
import { api } from '@/f1/service';
import moment from 'moment-timezone'
import codes from '@/f1/codes';
import { VclFacebook } from 'vue-content-loading';

const _i18n_data = {
  saved: {
    EN : `saved`,
    KO : `저장되었습니다`,
  },
  updated: {
    EN : `updated`,
    KO : `업데이트되었습니다`,
  },
  reload: {
    EN : `Saved! , reload 3 sec later`,
    KO : `저장 성공!, 3초 후 페이지가 새로고침됩니다`,
  },
  load : {
    EN : `load Successful`,
    KO : '데이터 불러오기 성공',
  },
  page_total : {
    EN : `all pages`,
    KO : '점검 대상 모든 페이지',
  },
  page : {
    EN : `Pages on the site`,
    KO : '점검 사이트의 페이지',
  },
  ext : {
    EN : `External page`,
    KO : '외부 페이지',
  },
  detect : {
    EN : `Detect page`,
    KO : '탐지 페이지',
  },
  binary : {
    EN : `Binary page`,
    KO : '바이너리 페이지',
  },
  resource : {
    EN : `Resource page`,
    KO : '리소스 페이지',
  },
  error : {
    EN : `Error page`,
    KO : '에러 페이지',
  }
};

export default {
  props: ['item', 'result_id'],
  components: { VueApexCharts, VclFacebook },
  watch : {
    result_id() {
      this.get()
    }
  },
  data : () => {
    return {
      loading : false,
      codes,
      moment,
      thumbnail_size: '100%',
      data_resource: [],
      data_site: [],
      options_site: {
        labels: [],
        legend: { position: 'bottom', }
      },
      options_resource: {
        labels: [],
        legend: { position: 'bottom', }
      },
      result : {
        page : { data: '', start: 0, end: 0 },
        ext: { data: '', start: 0, end: 0 },
        detect: { data: '', start: 0, end: 0 },
        resource: { data: '', start: 0, end: 0 },
        error: { data: '', start: 0, end: 0 }
      },
    }
  },

  computed: {
    i18n_data() { return _i18n_data; },
    page_set() {
      let rv = [];
      // for (let i = 0; i < this.result.page_data.length; i++) {
      //   for (let i = 0; i < this.result.page_data[i].length; i++) {
      //     rv.push(this.result.page_data[i][i])

      //   }
      //   // _.forEach(l, r => rv.push(r))
      // }
      _.forEach(this.result.page_data, l => _.forEach(l, r => rv.push(r)))
      return rv;
    },
    page_sub() { return _.groupBy(this.page_set, r => r[2]); },
    page_list() {
      let rv = [];
      let roots = _.filter(this.page_set, p => p[0] == 0);
      let subs = this.page_sub;
      let parser = r => r && `${r[8]} -- [${r[5]}, ${r[6] || '-'}, ${r[7]} bytes]` || '-';
      const builder = (r) => {
        let rv = [_.padStart('', r[0] * 2) + parser(r)];
        _.forEach(subs[r[1]], s => rv = rv.concat(builder(s))); // r[1] == this
        return rv;
      }

      // for (let i = 0; i < roots.length; i++) {
      //   rv.concat(builder(roots[i]))
      //   // const element = roots[i];
      //   // indexpython.
      // }

      _.forEach(roots, r => rv.concat(builder(r)));

      if(!rv.length) {
        let mains = this.page_set;
        rv = _.map(mains, r => { return [_.padStart('', r[0] * 2) + parser(r)] });
      }
      return rv;
    },
    error_list() {
      let parser = r => r && `${r[8]} -- [${r[5]}, ${r[6] || '-'}, ${r[7]} bytes]` || '-';
      return _.filter(this.page_set, x => _.filter(['40', '50'], c => x[5].startsWith(c)).length > 0).map(x => parser(x))
    },
    image() { return this.result.thumbnail && 'data:image/png;base64,' + this.result.thumbnail || 'img/no-image.png'; },
    ext_set() { return this.result.external_data || []; },
    resource_list() {
      let rv = [];
      _.forEach(this.result.resource_data || [], l => _.forEach(l, r => rv.push(r)));
      return rv;
    },
    ext_str() {
      // ver 1.0.1
      let rv = '';
      let parser = r => r && ` -- ${r[8]}\n` || ' -\n';
      _.forEach(this.ext_set, l => rv += (l[2] + parser(this.find_page(l[1]))));
      return rv;
    },
    ext_list() {
      let rv = [];
      _.forEach(this.ext_set, l => _.forEach(l, r => rv.push(r)));
      return rv;
    },
    detect_list() {
      let rv = [];
      _.forEach(this.result.detect_data || [], l => _.forEach(l, r => rv.push(`URL - ${r[6]} / Code (${r[2] || r[3]} ${codes.WMDS_TYPE[r[5]]} ${codes.WMDS_PATTRN_LEVEL[r[4]]})`)));
      return rv;
    },
  },
  methods: {
    scroll(target='page') {
      // console.log(target, "target")
      let div = this.$refs[target+"_list"];
      if(this.result[target].end >= this.result[target+"_count"]) { return; }
      if(div.clientHeight + div.scrollTop < div.scrollHeight) { return; }

      let add = _.slice(this[target+'_list'], this.result[target].end, this.result[target].end + 500);
      console.log('slice', add.length, this.result[target].end, this.result[target].end + 500);
      this.result[target].end += add.length;
      this.result[target].data += '\n' + _.join(add, '\n');
    },
    find_page(k) { return _.find(this.page_set, r => r[1] == k); },
    build() {
      try {

        let page = _.slice(this.page_list, 0, 500);
        let ext = _.slice(this.ext_list, 0, 500);
        let resource = _.slice(this.resource_list, 0, 500);
        let detect = _.slice(this.detect_list, 0, 500);
        this.result.page.data = _.join(page, '\n');
        this.result.page.end = page.length;

        this.result.error.data = _.join(this.error_list, '\n');
        this.result.error.end = this.error_list.length

        this.result.ext.data = _.join(ext, '\n');
        this.result.ext.end = ext.length;
        this.result.detect.data = _.join(detect, '\n');
        this.result.detect.end = detect.length;
        this.result.resource.data = _.join(resource, '\n');
        this.result.resource.end = resource.length;
      } catch (e) { console.error(e) }
    },
    get() {
      try {
        this.loading = true
        if(!(this.item && this.item.id)) {
          this.options_site.labels = []
          this.options_resource.labels = []
          this.data_resource = []
          this.data_site = []
          // request to result data
          let so = { target : 'result', cmd : 'detail', body : { id : this.result_id } }
          api.wmds.WMDS(so)
            .then(rs => {
              this.result = Object.assign({}, this.item, this.result, rs.body ? rs.body : {});
              // console.log(this.result, 'this.result')
              this.build()

              let site_page = this.result.page_count - this.result.ext_count - this.result.detect_count - this.result.binary_count

              this.data_site.push(site_page)
              this.options_site.labels.push(this.i18n_data['page'][this.i18n])

              this.data_site.push(this.result.ext_count)
              this.options_site.labels.push(this.i18n_data['ext'][this.i18n])

              this.data_site.push(this.result.detect_count)
              this.options_site.labels.push(this.i18n_data['detect'][this.i18n])

              this.data_site.push(this.result.binary_count)
              this.options_site.labels.push(this.i18n_data['binary'][this.i18n])

              this.data_site.push(this.result.error_count)
              this.options_site.labels.push(this.i18n_data['error'][this.i18n])


              // 리소스 구성
              this.data_resource.push(site_page)
              this.options_resource.labels.push(this.i18n_data['page'][this.i18n])

              this.data_resource.push(this.result.resource_count)
              this.options_resource.labels.push(this.i18n_data['resource'][this.i18n])


              // Object.keys(this.result).forEach(x => {
              //   try {
              //     if(x.endsWith("_count")) {
              //       this.data.push(this.result[x])
              //       this.options.labels.push(x.replace("_count", ''))
              //       total += this.result[x]
              //     }
              //   } catch (e) { console.error(e) }
              // })
              this.$toastr.i(this.i18n_data['load'][this.i18n])
              if(this.result.page_count < 1) {
                this.data_resource.push(100)
                this.options_resource.labels.push('inspection failed')
              }

              this.loading = false
            })
            .catch(e => {
              console.log(e)
              this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
            })
        } else { this.result = this.item }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
      // finally {
      //   this.loading = false
      // }
    },
  },
  // watch: { '$route' (to, from) { console.log("from", from) } },
  created() { console.log('result.detail.vue', 'created'); },
  destroyed() { console.log('result.detail.vue', 'destroyed'); },
  mounted() { console.log('result.detail.vue', 'mounted'); this.get(); },
}
